import { sleep } from '@flowus/common/async';
import { useEffect } from 'react';
import { message } from 'src/common/components/message';
import { useOpenModal } from 'src/common/components/next-modal';
import { Modals } from 'src/modals';
import { fetchSubscriptionData } from 'src/services/app/hook/subscription-data';
import { emitter } from '@flowus/common/utils/emitter';
import { OpenSettingFrom, SettingMenuType } from 'src/views/main/setting-modal/type';
import { useOpenSettingModal } from 'src/views/main/setting-modal/use-open-setting-modal';
import { getCurrentSpaceId } from '../space/get-space';
import { SearchParams } from 'src/utils';
import { OpenDialogEnum } from '../space/use-open-dialog-from-location';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

/** 接收emitter发送的消息，用于fn里需要唤起modal的需求 */
export const useListenerEmitterModal = () => {
  const { t } = useAppTranslation();
  const openModal = useOpenModal();
  const openSettingModal = useOpenSettingModal();

  const openMaximumCapacityDialog = (spaceId = getCurrentSpaceId()) => {
    openModal.warning({
      modalId: Modals.MAXIMUM_CAPACITY_DIALOG,
      title: t('hooks.listener_emitter_modal.trial_block_limit_reached'),
      confirmText: t('hooks.listener_emitter_modal.upgrade_unlimited_blocks'),
      forceUpdate: true,
      maxWidth: 350,
      colorType: 'active',
      footer: (
        <div className="text-t3 text-grey3 mt-2.5">
          {t('hooks.listener_emitter_modal.auto_update_info')}
          <span
            className="mx-0.5 animate-click underline underline-offset-2"
            onClick={async () => {
              message.loading({
                key: 'refreshCount',
                content: t('hooks.listener_emitter_modal.refreshing_count'),
              });
              await fetchSubscriptionData(spaceId);
              message.closeMessage('refreshCount');
              message.success(t('hooks.listener_emitter_modal.refresh_count_success'));
              openModal.closeModal(Modals.MAXIMUM_CAPACITY_DIALOG);
            }}
          >
            {t('hooks.listener_emitter_modal.refresh_count')}
          </span>
          {t('hooks.listener_emitter_modal.then_retry')}
        </div>
      ),
      confirm: () => {
        if (spaceId !== getCurrentSpaceId()) {
          message.success(t('hooks.listener_emitter_modal.switching_space'));
          // 切换空间再升级
          const params = new URLSearchParams();
          params.set(SearchParams.spaceId, spaceId);
          params.set(SearchParams.openDialog, OpenDialogEnum.openUpgradeSpace);
          window.location.href = `${window.location.origin}?${params.toString()}`;
          return;
        }
        openSettingModal({
          from: OpenSettingFrom.spaceSetBlock,
          defaultMenuType: SettingMenuType.upgrade,
        });
      },
    });
  };

  useEffect(() => {
    emitter.on('modalId', ({ modalId, spaceId }) => {
      // 弹的太快，可能会focus到button上，然后被同时监听回车事件的modal的confirm事件给触发了
      void sleep(100).then(() => {
        switch (modalId) {
          case Modals.MAXIMUM_CAPACITY_DIALOG:
            openMaximumCapacityDialog(spaceId);
            break;
          default:
            break;
        }
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
